export const TRANSACTION_LIST_FILTERS_STORAGE_PREFIX = 'transaction-list-filters-v1'

// Hapus semua filter daftar transaksi yang tersimpan (semua user & perusahaan di browser ini)
export const clearTransactionListFilters = () => {
  try {
    const keys = Object.keys(window.localStorage).filter((key) =>
      key.startsWith(`${TRANSACTION_LIST_FILTERS_STORAGE_PREFIX}:`),
    )
    keys.forEach((key) => {
      window.localStorage.removeItem(key)
    })
  } catch {
    // Browser storage bisa tidak tersedia (mis. Safari private mode).
  }
}
